module.exports = __webpack_public_path__ + "img/2.19e88997.jpeg";